<template>
  <!--begin::Page loader-->
  <!-- <template v-if="loaderType === 'spinner-message' && !menuLoaded">
    <div class="page-loader flex-column">
      <span class="spinner-border text-primary" role="status"></span>
      <span class="text-gray-600 fs-6 fw-bold mt-5">Loading...</span>
    </div>
  </template> -->
  <!-- <template v-if="loaderType === 'spinner-logo'"> -->
  <div class="page-loader flex-column">
    <img
      alt="Logo"
      src="/media/fit-media/logo-fitp.png"
      style="height: 13rem"
    />

    <div class="d-flex align-items-center mt-5">
      <span class="spinner-border text-primary" role="status"></span>
      <span class="text-gray-600 fs-6 fw-bold ms-5">Loading...</span>
    </div>
  </div>
  <!-- </template> -->
  <!-- <template v-else>
    <div class="page-loader">
      <span class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </span>
    </div>
  </template> -->
  <!--end::Page Loader-->
</template>

<script lang="ts">
import { defineComponent, computed, onBeforeMount, watch } from "vue";
import { useStore } from "vuex";

import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  name: "LoaderVue",
  props: {
    logo: String,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    onBeforeMount(async () => {
      const store = useStore();
      const isMenuLoaded = computed(() => store.getters.isMenuLoaded);
      if (!isMenuLoaded.value && !route.path.includes("/vt")) {
        await store.dispatch("getMenuFromApi", 0);
      }
      if (!route.path.includes("/vt")) {
        store.dispatch("lookupsStagioniFromApi");
      }
    });

    const loaderType = computed(() => {
      return store.getters.layoutConfig("loader.type");
    });

    return {
      loaderType,
      menuLoaded: computed(() => store.getters.isMenuLoaded),
      statusMenu: computed(() => store.getters.statusMenu),
    };
  },
});
</script>
